import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import moment from "moment";

// 法人基本設定マスター
const enterpriseCrewsBasicConditionsRepository = AiseaApiFactory.get(
  "enterpriseCrewsBasicConditions"
);

/**
 * 法人基本設定マスターサービス
 */
const EnterpriseCrewsBasicConditionsService = (() => {
  let _enterpriseCrewsBasicConditions = null;

  const fetch = async () => {
    const res = await enterpriseCrewsBasicConditionsRepository.fetch();
    if (!res || !res.status) {
      throw res;
    }
    _enterpriseCrewsBasicConditions = res.data;
    return _enterpriseCrewsBasicConditions;
  };

  /**
   * 引数の日付から会計年度を取得する
   * @param {Date} date - 日付オブジェクト
   * @returns {number} 会計年度
   */
  const getFiscalYear = date => {
    if (!_enterpriseCrewsBasicConditions) {
      return null;
    }
    const currentDate = moment(date);
    const currentYear = currentDate.year();

    // _enterpriseCrewsBasicConditions.fiscal_year_end_date から月と日のみを取得
    // ここでfiscal_year_end_dateは"YYYY-MM-DD"形式、または"MM-DD"形式の可能性があるので、
    // 年は無視して月と日だけを使用。
    const fiscalEndDateMoment = moment(
      _enterpriseCrewsBasicConditions.fiscal_year_end_date
    );
    const fiscalEndMonth = fiscalEndDateMoment.month(); // 0-indexed
    const fiscalEndDay = fiscalEndDateMoment.date();

    // 現在の暦年において、会計年度の開始日を決定
    // 会計年度末日の翌日が新しい会計年度の開始日
    const fiscalStartDateThisYear = moment()
      .year(currentYear)
      .month(fiscalEndMonth)
      .date(fiscalEndDay)
      .add(1, "days");

    let fiscalYear;

    // 計算対象の日付が、現在の暦年の会計年度開始日よりも前か後かで判断
    if (currentDate.isBefore(fiscalStartDateThisYear)) {
      // 例: 2025年3月15日 (会計年度末日3月31日、開始日4月1日) の場合
      // currentDate (2025/03/15) < fiscalStartDateThisYear (2025/04/01)
      // この場合、この日付は前年の会計年度に属する
      // 「2024年4月1日～2025年3月31日」が2024年度なので、2024年を返す
      fiscalYear = currentYear - 1;
    } else {
      // 例: 2025年6月13日 (会計年度末日3月31日、開始日4月1日) の場合
      // currentDate (2025/06/13) >= fiscalStartDateThisYear (2025/04/01)
      // この場合、この日付は現在の年の会計年度に属する
      // 「2025年4月1日～2026年3月31日」が2025年度なので、2025年を返す
      fiscalYear = currentYear;
    }

    return fiscalYear;
  };

  const clear = () => {
    _enterpriseCrewsBasicConditions = null;
  };

  return {
    fetch,
    clear,
    getFiscalYear,
  };
})();

export default EnterpriseCrewsBasicConditionsService;
